import type { EnumType } from "~/kernel/enums/EnumType";

const BookingMethod = Object.freeze({
  Online: "online",
  OnlineExisting: "onlineExisting",
  Email: "email",
  Phone: "phone",
});

type BookingMethod = EnumType<typeof BookingMethod>;

export default BookingMethod;
